import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LanguageModule } from '../language/language.module';
import { TranslationModule } from '../translation/translation.module';
import { RouterModule } from '@angular/router';
import { VerificationComponent } from './verification/verification.component';
import { VerificationMessageComponent } from './verification-message/verification-message.component';
import { VerificationForgotPasswordComponent } from './verification-forgot-password/verification-forgot-password.component';
import { VerificationForgotpasswordMessageComponent } from './verification-forgotpassword-message/verification-forgotpassword-message.component';
import { DeleteAccountPopupComponent } from '../login/personaldata/deleteaccountpopup/deleteaccountpopup.component';
import { MyordersComponent } from './myorders/myorders.component';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { RecaptchaComponent } from './recaptcha/recaptcha.component';
import { PersonalDataComponent } from './personaldata/personaldata.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateutilpipeModule } from '../dateutilpipe/dateutilpipe.module';




@NgModule({
    declarations: [VerificationComponent, VerificationMessageComponent, VerificationForgotPasswordComponent, VerificationForgotpasswordMessageComponent, PersonalDataComponent, MyordersComponent, SigninComponent, SignupComponent, ForgotpasswordComponent, DeleteAccountPopupComponent, RecaptchaComponent],
    exports: [SigninComponent],
    imports: [CommonModule, FormsModule, MatIconModule, LanguageModule, RouterModule, TranslationModule, MatDialogModule, ReactiveFormsModule, MatCheckboxModule, DateutilpipeModule],
    providers: [
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: { hasBackdrop: true }
        },
        {
            provide: MAT_RADIO_DEFAULT_OPTIONS,
            useValue: { color: 'black' }
        }



    ]
})
export class LoginModule { }
